import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCheckbox,{attrs:{"label":_vm.computeLabel(),"rules":_vm.computeRules()},model:{value:(_vm.form.certify),callback:function ($$v) {_vm.$set(_vm.form, "certify", $$v)},expression:"form.certify"}})
}
var staticRenderFns = []

export { render, staticRenderFns }